import tutorImg from '../../assets/images/tutor.jpg'
import { useEffect } from 'react'
export default ()=>{
    useEffect(()=>{
        document.title='安装指南'
    },[])
    return <img src={tutorImg} style={{width:'100%',margin:'0 auto'}} />
}